/* eslint-disable */
import React from 'react';
import { debounce } from 'lodash';
import { DEFAULT_NR_OF_RESULTS } from '../MobileLayout/MobileLayoutUtils';

const DEFAULT_DEBOUNCE_TIME = 50;

function isSearchBarInView(searchBarRef: React.RefObject<HTMLDivElement>): boolean {
  if (!searchBarRef.current) return false;

  const rect = searchBarRef.current.getBoundingClientRect();
  return (
    rect.top >= -90 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

const isContainerInView = (containerRef: React.RefObject<HTMLDivElement>) => {
  if (!containerRef.current) return false;

  const rect = containerRef.current.getBoundingClientRect();

  if (
    rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  )
    return false;

  return true;
};

export const handleVisibilityOnScroll = (
  searchBarRef: React.RefObject<HTMLDivElement>,
  containerRef: React.RefObject<HTMLDivElement>,
  setVisibility: React.Dispatch<React.SetStateAction<boolean>>,
  visible: boolean,
) =>
  debounce(() => {
    const searchBarInView = isSearchBarInView(searchBarRef);
    const containerInView = isContainerInView(containerRef);
    const currentVisibilityState = !searchBarInView && containerInView;
    if (visible !== currentVisibilityState) setVisibility(currentVisibilityState);
  }, DEFAULT_DEBOUNCE_TIME);

const shouldReactToScroll = (
  displayResultsLength: number,
  searchBarRef: HTMLDivElement | null,
  containerRef: HTMLDivElement | null,
) => {
  if (searchBarRef && containerRef) {
    return displayResultsLength > DEFAULT_NR_OF_RESULTS;
  }

  return false;
};

export const useHandleVisibility = (
  searchBarRef: React.RefObject<HTMLDivElement>,
  containerRef: React.RefObject<HTMLDivElement>,
  displayResultsLength: number,
) => {
  const [visible, setVisibility] = React.useState(false);

  const onScroll = handleVisibilityOnScroll(searchBarRef, containerRef, setVisibility, visible);

  React.useEffect(() => {
    if (shouldReactToScroll(displayResultsLength, searchBarRef.current, containerRef.current))
      window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [searchBarRef.current, containerRef.current, visible, displayResultsLength]);

  return visible;
};

export const handleOnClick = (searchBarRef?: React.RefObject<HTMLDivElement>) => () => {
  if (searchBarRef && searchBarRef.current)
    searchBarRef.current.scrollIntoView({ behavior: 'smooth' });
};
